import api from '../utils/api';
import config from '../config';

const alertConfigurationService = {
  // Get initialization data
  getInit: async () => {
    return api.get(config.endpoints.alertConfigurations.init);
  },

  // Get paginated list of alert configurations
  getAlertConfigurations: async (params) => {
    return api.get(config.endpoints.alertConfigurations.list, params);
  },

  // Get alert configuration by ID
  getAlertConfigurationById: async (id) => {
    return api.get(`${config.endpoints.alertConfigurations.list}/${id}`);
  },

  // Create new alert configuration
  createAlertConfiguration: async (alert) => {
    return api.post(config.endpoints.alertConfigurations.list, alert);
  },

  // Update alert configuration
  updateAlertConfiguration: async (id, alert) => {
    return api.put(`${config.endpoints.alertConfigurations.list}/${id}`, alert);
  },

  // Delete alert configuration
  deleteAlertConfiguration: async (id) => {
    return api.delete(`${config.endpoints.alertConfigurations.list}/${id}`);
  },

  // Toggle active status
  toggleActive: async (id) => {
    return api.put(`${config.endpoints.alertConfigurations.list}/${id}/toggle-active`);
  },
};

export default alertConfigurationService;

